export default __webpack_public_path__ + "static/media/img (3).d03a4ca5.jpg";